document.addEventListener("DOMContentLoaded", function() {
  if (!window.location.href.includes("products")) {
    document.body.classList.add("no-products");
  }
});

document.addEventListener("DOMContentLoaded", function () {
    function updateCountdown() {
      const targetDate = new Date("2025-03-29T08:00:00+01:00"); // vagy +02:00 ha már nyári időszámítás
      const now = new Date();
      const diff = targetDate - now;

      const el = document.getElementById("countdown-timer");
      if (!el) return;

      if (diff <= 0) {
        el.textContent = "Már megnyitottunk!";
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);

      el.innerHTML = `${days} nap ${hours} óra ${minutes} perc <span style="color: #F75C01;">a nyitásig</span>`;
    }

    updateCountdown();
    setInterval(updateCountdown, 60000); // frissítés percenként
  });
